module.exports = __webpack_public_path__ + "media/images/cureus_logo_black_2014-2e15742e1bfa7731309a9c8b15cdd241.png";